<template>
  <router-view></router-view>
</template>
<script>
  export default {
    name: 'Subnet'
  }
</script>



// WEBPACK FOOTER //
// subnet.vue?91cbb506